import React from 'react';
import PublicHeader from '../../components/public/Header/PublicHeader';
import PublicFooter from '../../components/public/Footer/PublicFooter';
import HeroSection from '../../components/public/sections/HeroSection';
import TrustProofSection from '../../components/public/sections/TrustProofSection';
import WorkflowSection from '../../components/public/sections/WorkflowSection';
import VerdeScoreSection from '../../components/public/sections/VerdeScoreSection';
import SecuritySection from '../../components/public/sections/SecuritySection';
import usePublicTheme from '../../hooks/usePublicTheme';
import styles from './HomePage.module.css';

const HomePage = () => {
  const { theme } = usePublicTheme();

  return (
    <div className={styles.pageContainer} data-theme={theme}>
      <PublicHeader />
      <main className={styles.mainContent}>
        <HeroSection />
        <TrustProofSection />
        <WorkflowSection />
        <VerdeScoreSection />
        <SecuritySection />
      </main>
      <PublicFooter />
    </div>
  );
};

export default HomePage;
